<template>
  <div style="width: 100%">
    <v-file-input
      max-width="100"
      :value="value"
      @change="openCropDialog($event)"
      v-model="files"
      @click="files = null"
      label="Foto"
      prepend-icon="mdi-cloud-upload"
    ></v-file-input>

    <ImageCropper
      v-if="dialogCroper"
      :dialogCroper="dialogCroper"
      :imgSrc="imgSrc"
      @setCropedImage="setCropedImage($event)"
      @closeImageCroper="closeImageCroper()"
    />
    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
  </div>
</template>
<script>
import { firebase } from "@/firebaseConfig";
import Loader from "@/components/common/Loader";
import ImageCropper from "@/components/common/ImageCropper";
export default {
  name: "CategoryDialog",
  components: { ImageCropper, Loader },
  props: ["value", "type"],
  data: () => ({
    imgSrc: "",
    dialogCroper: false,
    imageData: "",
    fileName: "",
    dialogLoader: false,
    files: null
  }),
  methods: {
    openCropDialog(imageData) {
      if (imageData) {
        this.imageData = imageData;
        this.fileName = imageData ? this.randomId() + imageData.name : "";
        if (imageData && imageData.type.indexOf("image/") === -1) {
          return;
        }
        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = event => {
            this.imgSrc = event.target.result;
            this.dialogCroper = true;
          };
          reader.readAsDataURL(imageData);
        } else {
          this.showInfoMessage("Sorry, FileReader API not supported");
        }
      }
    },
    closeImageCroper() {
      this.dialogCroper = false;
      this.dialogLoader = false;
      this.imgSrc = "";
    },
    setCropedImage(imageData) {
      let file = new File([imageData], this.fileName, {
        type: this.imageData.type
      });
      this.onUpload(file);
      this.dialogCroper = false;
    },
    onUpload(imageData) {
      if (imageData) {
        this.dialogLoader = true;
        const storageRef = firebase
          .storage()
          .ref(`${imageData.name}`)
          .put(imageData);
        storageRef.on(
          `state_changed`,
          snapshot => {
            this.uploadValue =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          error => {
            // eslint-disable-next-line
            console.log(error.message);
            this.dialogLoader = false;
          },
          () => {
            this.uploadValue = 100;
            storageRef.snapshot.ref.getDownloadURL().then(url => {
              //this.input.image = url;
              let data = {
                url: url,
                type: this.type
              };
              this.$emit("setImageUrl", data);
              this.dialogCroper = false;
              this.dialogLoader = false;
            });
          }
        );
      }
    }
  }
};
</script>
